require("./threepl-services-settings-panel-content.scss");

import {ChangeDetectionStrategy, Component, computed, inject, output, signal} from "@angular/core";
import {bzIconChevronDown, bzIconChevronUp} from "@bringoz/ui/icons";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {ThreePLServicesDynamicColumn, ThreePLServicesSettings} from "../../models/threepl-services-list.model";

export interface ThreePLServicesSettingsPanelData {
  defaultGroup?: string;
  columns?: Record<string, boolean>;
  dynamicColumns?: ThreePLServicesDynamicColumn[];
  columnSizes?: Record<string, number>;
  columnOrder?: string[];
  resetColumns: Record<string, boolean>;
}

interface Sections {
  totalColumns: boolean;
  viewSettings: boolean;
  dynamicColumns: boolean;
}

@Component({
  selector: "app-threepl-services-settings-panel-content",
  templateUrl: "./threepl-services-settings-panel-content.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServicesSettingsPanelContentComponent {
  private readonly data = inject<ThreePLServicesSettingsPanelData>(PANEL_DATA);
  readonly onClose = output<ThreePLServicesSettings | undefined>();

  readonly icons = {expand: bzIconChevronDown, collapse: bzIconChevronUp};

  readonly sections = signal<Sections>({totalColumns: false, viewSettings: false, dynamicColumns: false});
  readonly settings = signal<ThreePLServicesSettings>({
    defaultGroup: this.data.defaultGroup,
    columns: this.data.columns,
    dynamicColumns: this.data.dynamicColumns,
    columnSizes: this.data.columnSizes,
    columnOrder: this.data.columnOrder,
  });

  readonly columnEntries = computed(() => Object.entries(this.settings().columns ?? {}).map(([key, enabled]) => ({key, enabled})));

  toggleSection(section: keyof Sections): void {
    this.sections.update((sections) => ({...sections, [section]: !sections[section]}));
  }


  onChangeColumn(columnKey: string, isEnabled: boolean): void {
    this.settings.update((settings) => ({...settings, columns: {...settings.columns, [columnKey]: isEnabled}}));
  }

  onDynamicColumnChange(index: number, enabled: boolean): void {
    this.settings.update((settings) => ({
      ...settings,
      dynamicColumns: settings.dynamicColumns.map((column, i) => (i === index ? {...column, enabled} : column)),
    }));
  }

  onDefaultGroupChange(defaultGroup: string): void {
    this.settings.update((settings) => ({...settings, defaultGroup}));
  }

  onReset(): void {
    this.settings.set({defaultGroup: undefined, columns: this.data.resetColumns});
    this.onSubmit();
  }

  onSubmit(): void {
    this.onClose.emit(this.settings());
  }

  onCancel(): void {
    this.onClose.emit(undefined);
  }
}
